import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';

export default function Time({ symbolId }) {
    const symbol = useSelector(state => state.updateSymbol.symbols?.[symbolId]);
    const { UserCompleteDetails } = useSelector((state) => state.user);

    const [now, setNow] = useState(moment.utc());

    useEffect(() => {
        const interval = setInterval(() => {
            setNow(moment.utc());
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    const offsetToMinutes = (offset) => {
        const [hours, minutes, seconds] = offset.split(":").map(Number);
        return hours * 60 + minutes + Math.sign(hours) * (seconds > 0 ? 1 : 0);
    };

    const applyClientOffset = (utcTime) => {
        const clientOffsetMin = offsetToMinutes(UserCompleteDetails?.gmtOffset || "00:00:00");
        return utcTime.clone().add(clientOffsetMin, "minutes").format("HH:mm:ss");
    };

    const formatDateTime = (serverDateTime) => {
        if (!serverDateTime) return "--";
        const serverTime = moment.parseZone(serverDateTime);
        const serverOffsetMin = offsetToMinutes(UserCompleteDetails?.serverGMTOffset || "00:00:00");
        const clientOffsetMin = offsetToMinutes(UserCompleteDetails?.gmtOffset || "00:00:00");
        const diffOffset = clientOffsetMin - serverOffsetMin;
        return serverTime.add(diffOffset, "minutes").format("HH:mm:ss");
    };

    const displayTime =
        symbol?.bidColor && symbol?.askColor
            ? applyClientOffset(now)
            : symbol?.lastQuoteTime
                ? formatDateTime(symbol.lastQuoteTime)
                : '--';

    return <span>{displayTime}</span>;
}


